import { Typography } from "@mui/material";

type EmailFieldProps = {
  value: string;
};

export function EmailField({ value }: EmailFieldProps) {
  return <Typography variant="body1">{value}</Typography>;
}
